// C2／C3／C5 共用的下載 PDF 按鈕：攔截表單送出改用 fetch 打
// Admin::QuotesController#export，成功後就地更新按鈕文字與 C2-3 版本清單，
// 不整頁重新整理。實際檔案下載改用瀏覽器對 blob URL 的一般導覽觸發——
// 回應帶 Content-Disposition: attachment，分頁不會真的跳走，只會觸發下載
document.addEventListener('submit', function (event) {
  const form = event.target.closest('.quote-export-form');
  if (!form) return;

  event.preventDefault();

  const button = form.querySelector('.quote-export-label');
  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = '產生中…';

  fetch(form.action, {
    method: 'POST',
    headers: { 'X-CSRF-Token': getCsrfToken(), Accept: 'application/json' }
  })
    .then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    })
    .then(function (result) {
      if (!result.ok) {
        alert(result.data.error || '下載失敗，請重試');
        button.disabled = false;
        button.textContent = originalLabel;
        return;
      }

      document.querySelectorAll('.quote-export-label').forEach(function (label) {
        label.textContent = originalLabel;
        label.disabled = false;
      });

      const exportsTab = document.getElementById('quote-tab-exports');
      if (exportsTab && result.data.exports_list_html) {
        exportsTab.innerHTML = result.data.exports_list_html;
      }

      window.location.href = result.data.download_url;
    })
    .catch(function () {
      alert('網路錯誤，請重試');
      button.disabled = false;
      button.textContent = originalLabel;
    });
});

function getCsrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : '';
}
